import { useEffect, useState } from 'react'
import posthog from 'posthog-js'
import sessionService, {
  type UserDto,
} from '@/features/session/data/session.service.ts'

/**
 * Identifies the current user to PostHog
 */
export function usePosthogIdentify(): void {
  const [user, setUser] = useState<UserDto | null>(null)

  useEffect(() => {
    void sessionService.getCurrentUser().then(setUser)
  }, [])

  useEffect(() => {
    if (user) {
      posthog.identify(user.id, {
        email: user.email,
        name: user.firstName + ' ' + user.lastName,
      })
    }
  }, [user])
}
